
import React from 'react';
import { FileText, Plus } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface EmptyUploadsStateProps {
  onCreateClick: () => void;
}

const EmptyUploadsState: React.FC<EmptyUploadsStateProps> = ({ onCreateClick }) => {
  return (
    <div className="text-center py-12">
      <FileText className="mx-auto h-12 w-12 text-muted-foreground/40" />
      <h3 className="mt-4 text-lg font-medium">No uploads yet</h3>
      <p className="mt-2">
        Start sharing your music by creating your first track download.
      </p>
      <Button className="mt-4" onClick={onCreateClick}>
        <Plus size={16} className="mr-2" />
        Create Your First Upload
      </Button>
    </div>
  );
};

export default EmptyUploadsState;
